import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ApiKeysState } from './api-keys.reducer';

/**
 * API Keys Selectors
 */

// Feature selector
export const selectApiKeysState = createFeatureSelector<ApiKeysState>('apiKeys');

// API Keys list selectors
export const selectApiKeys = createSelector(
  selectApiKeysState,
  (state) => state.apiKeys
);

export const selectApiKeysTotal = createSelector(
  selectApiKeysState,
  (state) => state.total
);

export const selectApiKeysPagination = createSelector(
  selectApiKeysState,
  (state) => ({
    page: state.page,
    page_size: state.page_size,
    total_pages: state.total_pages,
    has_next: state.has_next,
    has_prev: state.has_prev,
    total: state.total
  })
);

export const selectApiKeysFilters = createSelector(
  selectApiKeysState,
  (state) => state.filters
);

// Selected API key selectors
export const selectSelectedApiKey = createSelector(
  selectApiKeysState,
  (state) => state.selectedApiKey
);

// Newly created key selector (contains actual key - shown only once!)
export const selectNewlyCreatedKey = createSelector(
  selectApiKeysState,
  (state) => state.newlyCreatedKey
);

// Rotated key selector (contains new key - shown only once!)
export const selectRotatedKey = createSelector(
  selectApiKeysState,
  (state) => state.rotatedKey
);

// Usage stats selector
export const selectUsageStats = createSelector(
  selectApiKeysState,
  (state) => state.usageStats
);

// Loading state selectors
export const selectApiKeysLoading = createSelector(
  selectApiKeysState,
  (state) => state.loading
);

export const selectApiKeyLoading = createSelector(
  selectApiKeysState,
  (state) => state.loadingApiKey
);

export const selectUsageStatsLoading = createSelector(
  selectApiKeysState,
  (state) => state.loadingUsageStats
);

export const selectCreating = createSelector(
  selectApiKeysState,
  (state) => state.creating
);

export const selectUpdating = createSelector(
  selectApiKeysState,
  (state) => state.updating
);

export const selectRevoking = createSelector(
  selectApiKeysState,
  (state) => state.revoking
);

export const selectRegenerating = createSelector(
  selectApiKeysState,
  (state) => state.regenerating
);

export const selectRotating = createSelector(
  selectApiKeysState,
  (state) => state.rotating
);

// Error state selectors
export const selectApiKeysError = createSelector(
  selectApiKeysState,
  (state) => state.error
);

export const selectCreateError = createSelector(
  selectApiKeysState,
  (state) => state.createError
);

export const selectUpdateError = createSelector(
  selectApiKeysState,
  (state) => state.updateError
);

export const selectRevokeError = createSelector(
  selectApiKeysState,
  (state) => state.revokeError
);

export const selectRotateError = createSelector(
  selectApiKeysState,
  (state) => state.rotateError
);

export const selectUsageStatsError = createSelector(
  selectApiKeysState,
  (state) => state.usageStatsError
);

// Computed selectors
export const selectActiveApiKeys = createSelector(
  selectApiKeys,
  (apiKeys) => apiKeys.filter(key => key.is_active)
);

export const selectRevokedApiKeys = createSelector(
  selectApiKeys,
  (apiKeys) => apiKeys.filter(key => !key.is_active)
);

export const selectApiKeysCount = createSelector(
  selectApiKeys,
  (apiKeys) => apiKeys.length
);

export const selectActiveApiKeysCount = createSelector(
  selectActiveApiKeys,
  (apiKeys) => apiKeys.length
);

// Get API key by ID
export const selectApiKeyById = (keyId: string) => createSelector(
  selectApiKeys,
  (apiKeys) => apiKeys.find(key => key.id === keyId)
);

